define('views/app/member/setting/personal/personal-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/modules/profile/blocks/personal-info',
    'views/modules/profile/blocks/preferences-personal',
    // Templates Blocks
    'text!templates/app/member/setting/personal/personal-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // Views
    VProfilePersonalInfo,
    VProfilePreferencesPersonal,
    // Template
    TPersonalContent
) {

    var VMemberPersonalContent = Backbone.View.extend({

        template: TPersonalContent,

        // abstracting selectors out of the view logic
        regions: {
            payments: "#setting-payments",
            personalInfo: "#setting-personal-info",
            preferences: "#setting-preferences",
        },

        initialize: function(opt) {
            var model = this.model,
                view = this.view = {
                    personalInfo: new VProfilePersonalInfo({ model: model }),
                    preferences: new VProfilePreferencesPersonal({
                        model: model,
                        group: opt.group
                    }),
                };

            var viewCallbacks = { 'panel:stack': this.onStack };
            this.listenTo(view.personalInfo, viewCallbacks)
                .listenTo(view.preferences, viewCallbacks)
                .listenTo(view.customData, viewCallbacks);
                // .listenTo(view.payments, viewCallbacks);
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();

            var view = this.view,
                zone = this.zone;

            this.assign(view.personalInfo, zone.$personalInfo)
                .assign(view.preferences, zone.$preferences);
                // .assign(view.payments, zone.$payments);

            return this;
        },

        onStack: function(view) {
            this.trigger('panel:stack', view);
        },

    });

    return VMemberPersonalContent;

});

